import { FamilyMotherDetailAnscNotificationsMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsMotherDetailCivilStatusShared from 'shell/components/shared/ansc-notifications/research-family/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchFamilyNotificationsMotherDetailCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsMotherDetailCivilStatusShared
        items={FamilyMotherDetailAnscNotificationsMutationCrumbs()}
        scope={IdAmbito.Mutazioni}
      />
    </Fragment>
  );
};

ResearchFamilyNotificationsMotherDetailCivilStatusPage.displayName =
  'Research Family Notifications CivilStatusPage component';

export default ResearchFamilyNotificationsMotherDetailCivilStatusPage;
